import React from "react";
import ContentLoader from "react-content-loader";
import { Container } from "./styles";
import { useTheme as useStyledTheme } from "styled-components";

const DecLoadingSkeleton = ({ isDark = true }) => {
  const theme = useStyledTheme();
  const backgroundColor = theme?.card || (isDark ? "#1a1a1a" : "#f0f0f0");
  const foregroundColor = theme?.card2 || (isDark ? "#2a2a2a" : "#e5e7eb");

  return (
    <Container>
      <div className="content-wrapper">
        {/* KPI Cards - 4 cards */}
        <div style={{ display: "flex", gap: "0.8em", height: "70px", margin: "0 0 1em 0" }}>
          {[1, 2, 3, 4].map((i) => (
            <div
              key={`kpi-${i}`}
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "18px 16px",
                height: "70px",
                background: theme?.card || (isDark ? "#1e1e1e" : "#ffffff"),
                border: `1px solid ${theme?.border || (isDark ? "#333" : "#e5e7eb")}`,
                borderRadius: "14px",
              }}
            >
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: theme?.card2 || (isDark ? "#2a2a2a" : "#f5f5f5"),
                }}
              >
                <ContentLoader
                  speed={2}
                  width={36}
                  height={36}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="8" y="8" rx="4" ry="4" width="20" height="20" />
                </ContentLoader>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <ContentLoader
                  speed={2}
                  width={50}
                  height={20}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="4" ry="4" width="50" height="20" />
                </ContentLoader>
                <ContentLoader
                  speed={2}
                  width={80}
                  height={10}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="80" height="10" />
                </ContentLoader>
              </div>
            </div>
          ))}
        </div>

        {/* Toolbar */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "12px 16px",
            background: theme?.card2 || (isDark ? "#1e1e1e" : "#f9f9f9"),
            border: `1px solid ${theme?.border || (isDark ? "#333" : "#e5e7eb")}`,
            borderRadius: "10px",
            marginBottom: "0.8em",
          }}
        >
          <ContentLoader
            speed={2}
            width={80}
            height={32}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
          >
            <rect x="0" y="0" rx="6" ry="6" width="80" height="32" />
          </ContentLoader>
          <ContentLoader
            speed={2}
            width={90}
            height={32}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
          >
            <rect x="0" y="0" rx="6" ry="6" width="90" height="32" />
          </ContentLoader>
          <ContentLoader
            speed={2}
            width={110}
            height={32}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
          >
            <rect x="0" y="0" rx="6" ry="6" width="110" height="32" />
          </ContentLoader>
          <ContentLoader
            speed={2}
            width={200}
            height={32}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
          >
            <rect x="0" y="0" rx="6" ry="6" width="200" height="32" />
          </ContentLoader>
        </div>

        {/* List Card */}
        <div
          style={{
            background: theme?.card || (isDark ? "#1e1e1e" : "#ffffff"),
            border: `1px solid ${theme?.border || (isDark ? "#333" : "#e5e7eb")}`,
            borderRadius: "12px",
            overflow: "hidden",
            flex: 1,
          }}
        >
          {/* Card Header */}
          <div
            style={{
              padding: "0.5em 1.2em",
              height: "2em",
              display: "flex",
              alignItems: "center",
              borderBottom: `1px solid ${theme?.border || (isDark ? "#333" : "#e5e7eb")}`,
            }}
          >
            <ContentLoader
              speed={2}
              width={150}
              height={14}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
            >
              <rect x="0" y="0" rx="3" ry="3" width="150" height="14" />
            </ContentLoader>
          </div>

          {/* List Items */}
          <div>
            {[...Array(8)].map((_, i) => (
              <div
                key={`item-${i}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1em",
                  padding: "0.8em 1em",
                  borderBottom: i < 7 ? `1px solid ${theme?.border || (isDark ? "#333" : "#e5e7eb")}` : "none",
                  opacity: 0.85,
                }}
              >
                <div
                  style={{
                    width: "2.5em",
                    height: "2.5em",
                    minWidth: "2.5em",
                    borderRadius: "6px",
                    background: theme?.card2 || (isDark ? "#2a2a2a" : "#f5f5f5"),
                  }}
                >
                  <ContentLoader
                    speed={2}
                    width={40}
                    height={40}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="8" y="8" rx="4" ry="4" width="24" height="24" />
                  </ContentLoader>
                </div>
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "0.3em" }}>
                  <ContentLoader
                    speed={2}
                    width={250}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="250" height="14" />
                  </ContentLoader>
                  <ContentLoader
                    speed={2}
                    width={180}
                    height={11}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="180" height="11" />
                  </ContentLoader>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default DecLoadingSkeleton;
